// components/shared/Button.jsx
export function Button({
  children,
  variant = "primary",
  size = "md",
  onClick,
  disabled = false,
  loading = false,
  type = "button",
  className = "",
  primaryColor = "#ea580c",
}) {
  const isDisabled = disabled || loading;

  const base =
    "inline-flex items-center justify-center gap-2 font-semibold transition-all " +
    "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-900 " +
    "disabled:opacity-50 disabled:cursor-not-allowed select-none";

  const sizes = {
    sm: "px-3 py-1.5 text-xs rounded-lg",
    md: "px-4 py-2 text-sm rounded-xl",
    lg: "px-5 py-2.5 text-sm rounded-xl",
  };

  const variants = {
    primary: {
      style: {
        background: `linear-gradient(to right, ${primaryColor}, ${primaryColor}dd)`,
        color: "white",
        boxShadow: `0 10px 25px -10px ${primaryColor}66`,
      },
      className: "hover:opacity-95 active:scale-[0.99]",
    },
    secondary:
      "bg-slate-800/60 border border-slate-700 text-white hover:bg-slate-800/80",
    ghost:
      "bg-transparent border border-slate-700 text-slate-200 hover:bg-slate-800/40 hover:text-white",
    danger:
      "bg-red-600/10 border border-red-500/30 text-red-300 hover:bg-red-600/20",
    success:
      "bg-green-600/10 border border-green-500/30 text-green-300 hover:bg-green-600/20",
  };

  const v = variants[variant] ?? variants.primary;
  const isCustom = typeof v === "object";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={`${base} ${sizes[size]} ${isCustom ? v.className : v} ${className}`}
      style={isCustom ? v.style : undefined}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      <span>{children}</span>
    </button>
  );
}
